import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import peerAnalysisService from './peerAnalysisService'

export const postMoveOrCopyCompany = createAsyncThunk(
  'peerAnalysis/postMoveOrCopyCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await peerAnalysisService.postMoveOrCopyCompany(params)

      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)
